<template>
  <section>
    <h2 class="h2Title">참여 신청 인원</h2>

    <article class="tableWrap">
      <div class="tableBtnBx">
        <p class="searchAll">
<!--          <v-checkbox class="mgr" label="" v-model="all" :true-value="true" :false-value="false"/>-->
          {{ meeting.title }} 총 <span class="txtPoint">{{ totalItems }} </span> 명
        </p>

        <div class="tableBtn">
          <ul>
            <li class="tableBtnList"><span class="black-color">{{ selected.length }}</span> 건 선택됨</li>
            <li class="tableBtnList">
              <v-btn color="#58d8a3" depressed dark @click="smsDialogVisible=true">SMS 발송</v-btn>
            </li>
            <li class="tableBtnList">
              <v-btn color="#ffc105" depressed dark @click="mailDialogVisible=true">Mail 발송</v-btn>
            </li>
          </ul>
        </div>
      </div>

      <div class="tableBx">
        <v-data-table
            v-model="selected"
            :headers="headers"
            :items="dataset"
            item-key="idx"
            class="elevation-1"
            :footer-props="{showFirstLastPage: true}"
            show-select
        >
          <template v-slot:item.idx="{item}">
            {{item.idx}}
          </template>
          <template v-slot:item.duesType="{value}">
            <template v-for="(t, index) in duesTypeItems">
              <span v-if="t.value === value" :key="index"> {{t.text}} </span>
            </template>
          </template>
          <template v-slot:item.amount="{value}">
            {{ value | numeralFormat('0,000')}}
          </template>

          <template v-slot:item.payDt="{ value }">
            {{ value | moment('YYYY-MM-DD') }}
          </template>

          <template v-slot:item.deposited="{ value, item }">
            <template v-if="!value">
              <v-chip
                  class="ma-2"
                  color="orange"
                  text-color="white"
              >
              대기
              </v-chip>
              <v-btn @click="depositForm(item)" small style="margin-left:4px">
                완료처리
              </v-btn>
            </template>
            <template v-else>
              <v-chip
                  class="ma-2"
                  color="success"
                  text-color="white"
              >
                완료
              </v-chip>
              <v-btn @click="deposit(item)" small style="margin-left:4px">
                대기처리
              </v-btn>
            </template>
<!--            <v-btn color="primary" depressed dark @click="depositForm(item)" v-else small>-->
<!--              <v-icon x-small left>mdi-bank</v-icon>-->
<!--              입금-->
<!--            </v-btn>-->
          </template>

          <template v-slot:item.refunded="{ value, item }">
            <template v-if="item.deposited && !value">
              <v-chip
                  class="ma-2"
                  color="orange"
                  text-color="white"
              >
                입금
              </v-chip>
              <v-btn @click="refund(item)" small style="margin-left:4px">
                환불처리
              </v-btn>
            </template>

            <template v-else-if="value">
              <v-chip
                  class="ma-2"
                  color="success"
                  text-color="white"
              >
                완료
              </v-chip>
              <v-btn @click="refund(item)" small style="margin-left:4px">
                환불취소
              </v-btn>
            </template>

            <template v-else>
              입금 대기
            </template>

          </template>

          <template v-slot:item.attendance="{ value, item }">
            <template v-if="item.completed">
              <v-chip
                  class="ma-2"
                  color="primary"
                  text-color="white"
              >
                완료
              </v-chip>
            </template>

            <template v-else-if="value">
              <v-chip
                  class="ma-2"
                  color="success"
                  text-color="white"
              >
                진행
              </v-chip>
              <v-btn @click="attendance(item)" small style="margin-left:4px">
                취소처리
              </v-btn>
            </template>

            <template v-else>
              <v-chip
                  class="ma-2"
                  color="orange"
                  text-color="white"
              >
                취소
              </v-chip>
              <v-btn @click="attendance(item)" small style="margin-left:4px">
                참석처리
              </v-btn>

            </template>

          </template>

        </v-data-table>
      </div>
    </article>

    <div class="btnStyleBx">
      <div class="btnCommon justify-center">
        <router-link to="..">
          <v-btn class="vBtn" color="#fafafa">
            <v-icon left>mdi mdi-format-list-bulleted</v-icon>
            모임 목록
          </v-btn>
        </router-link>
      </div>
    </div>

    <v-dialog v-model="dialogVisible" max-width="500px" @click:outside="dialogVisible = false" @keydown.esc="dialogVisible = false">
      <v-card>
        <v-card-title>
          <span class="headline">입금내역 확인</span>
        </v-card-title>

        <v-card-text>
          <div class="fieldWrap mgb2">
            <ul class="fieldBx">
              <li class="formList">
                <dl>
                  <dt class="formTit">이름</dt>
                  <dd class="mgr">
                    <v-col sm="2">
                      {{meetingUser.name}}
                    </v-col>
                  </dd>
                </dl>
              </li>
              <li class="formList">
                <dl>
                  <dt class="formTit">모임 제목</dt>
                  <dd class="mgr">
                    <v-col sm="2">
                      {{meeting.title}}
                    </v-col>
                  </dd>
                </dl>
              </li>
              <li class="formList">
                <dl>
                  <dt class="formTit">가족 동반</dt>
                  <dd class="mgr">
                    <v-col sm="2">
                      {{meetingUser.familyCount}}
                    </v-col>
                  </dd>
                </dl>
              </li>
              <li class="formList">
                <dl>
                  <dt class="formTit">모임 비용</dt>
                  <dd class="mgr">
                    <v-col sm="2">
                      {{meeting.entryFee}}
                    </v-col>
                  </dd>
                </dl>
              </li>
            </ul>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" dark @click="dialogVisible = false">창닫기</v-btn>
          <v-btn color="primary" dark @click="completeDeposit(meetingUser)">입금 완료</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="smsDialogVisible" max-width="350px" @click:outside="smsDialogVisible = false" @keydown.esc="smsDialogVisible = false">
      <v-card class="mx-auto">
        <v-system-bar>
          SMS 발송
          <v-spacer></v-spacer>
          <v-icon @click="smsDialogVisible = false">mdi-close</v-icon>
        </v-system-bar>
        <v-card-text>

          <mobile-component
              :selected="selected"
              @callback-event = "v => smsDialogVisible = !v"
          />

        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="mailDialogVisible" max-width="600px" @click:outside="mailDialogVisible = false" @keydown.esc="mailDialogVisible = false">
      <v-card class="mx-auto">
        <v-system-bar>
          메일 발송
          <v-spacer></v-spacer>
          <v-icon @click="mailDialogVisible = false">mdi-close</v-icon>
        </v-system-bar>
        <v-card-text>

          <mail-component
              :selected="selected"
              :is-part="true"
              @callback-event = "v => mailDialogVisible = !v"
          />

        </v-card-text>
      </v-card>
    </v-dialog>

  </section>
</template>

<script>
import meetingUserApi from '@/api/MeetingUserApi'
import meetingApi from "@/api/MeetingApi";

import mobileComponent from "@/views/component/MobileComponent";
import mailComponent from "@/views/component/MailComponent";

// import _ from 'lodash';

export default {
  name: "MeetingUserList",
  components: {
    mobileComponent, mailComponent
  },
  props: {
    meetingId: String
  },
  data: () => ({
    all: false,
    selected: [],
    headers: [
      {text: 'No', value: 'idx'},
      {text: '아이디', value: 'userId'},
      {text: '이름', value: 'name'},
      {text: '이메일', value: 'email'},
      {text: '휴대폰번호', value: 'mobileNo'},
      {text: '전자 부서', value: 'retirementDepartment'},
      {text: '전자 직위', value: 'retirementPosition'},
      {text: '가족동반', value: 'familyCount'},
      {text: '입금상태', value: 'deposited'},
      {text: '환불상태', value: 'refunded'},
      {text: '참여상태', value: 'attendance'},
    ],
    param: {
      fromJoin: null,
      toJoin: null,
      page: 1
    },
    options:{},
    dataset: [],
    totalItems: 0,
    dialogVisible: false,
    smsDialogVisible: false,
    mailDialogVisible: false,
    duesTypeItems: [
      {value:'TYPE_DUES_ECLUB', text:'전자사랑 연회비'},
      {value:'TYPE_DUES_DEPARTMENT_YEAR', text:'분과 연회비'},
      {value:'TYPE_DUES_DEPARTMENT_MEETING', text:'분과 모임비'},
      {value:'TYPE_DUES_CLUB_YEAR', text:'동호회 연회비'},
      {value:'TYPE_DUES_CLUB_MEETING', text:'동호회 모임비'}
    ],
    meeting:{},
    meetingUser: {}
  }),
  watch: {
  },
  methods: {
    search(item) {
      const legacy = this.dataset.filter(d => d.userId === item.userId)?.[0]??null;
      const idx = this.dataset.indexOf(legacy);

      if(idx >= 0) {
        this.dataset[idx] = Object.assign(this.dataset[idx], item)
      }

      // const {  page, itemsPerPage, size } = this.options;
      // const params = {...this.param, ...{
      //     page: page,
      //     size: size ? size : itemsPerPage
      //   }};
      // if (this.activeItem > 0) {
      //   params.fromDate = this.searchDate[0];
      //   params.toDate = this.searchDate[1];
      // } else {
      //   params.fromDate = null;
      //   params.toDate = null;
      // }
      //
      // params.userId = this.userId;

      // meetingUserApi.list(this.meetingId).then(data => {
      //   this.totalItems = data.totalElements;
      //   this.dataset = data.content.map((d, i) => {
      //     d.idx = this.totalItems - i - (( (data.pageable.offset+1) - 1) * data.pageable.pageSize);
      //     return d;
      //   });
      // });
    },
    depositForm(item) {
      this.meetingUser = item;
      this.dialogVisible = true;
      this.activeAmount = 0;
    },
    deposit(item) {
      if(confirm('입금 대기 처리 하시겠습니까?')) {
        meetingUserApi.changeDeposit(item.meetingId, item.userId).then(() => {
          item.deposited = !item.deposited;
          this.search(item);
          alert("완료되었습니다.");
        });
      }
    },
    refund(item) {
      if(confirm('환불 상태를 '+ (item.refunded ? '환불 취소' : '환불 완료') +'로 변경 하시겠습니까?')) {
        meetingUserApi.changeRefund(item.meetingId, item.userId).then(() => {

          item.refunded = !item.refunded;
          this.search(item);
          alert("완료되었습니다.");
        });
      }
    },
    attendance(item) {
      if(confirm('참여 상태를 ' + (item.attendance ? '취소' : '참여') +'로 변경 하시겠습니까?')) {
        meetingUserApi.changeAttendance(item.meetingId, item.userId).then(() => {

          item.attendance = !item.attendance;
          this.search(item);
          alert("완료되었습니다.");
        });
      }
    },
    async completeDeposit(item) {
      if(confirm('입금 완료 하시겠습니까?')) {
        meetingUserApi.completeDeposit(this.meetingUser.meetingId, this.meetingUser.userId).then(() => {
          item.deposited = !item.deposited;
          this.search(item);
          this.dialogVisible = false;
          alert("입금 완료되었습니다.");
        });
      }
    }
  },
  created: function () {
    meetingApi.get(this.meetingId).then(data => {
      this.meeting = data;
    });

    meetingUserApi.list(this.meetingId).then(data => {
      // const temp = [..._.cloneDeep(data),..._.cloneDeep(data),..._.cloneDeep(data),..._.cloneDeep(data),..._.cloneDeep(data),..._.cloneDeep(data),..._.cloneDeep(data),..._.cloneDeep(data)];
      this.totalItems = data.length
      this.dataset = data.map((d, i) => {
        d.idx = this.totalItems - i
        return d;
      });
      // this.totalItems = data.totalElements;
      // this.dataset = data.content.map((d, i) => {
      //   d.idx = this.totalItems - i - (( (data.pageable.offset+1) - 1) * data.pageable.pageSize);
      //   return d;
      // });
    });
  }
}
</script>


<style lang="scss" scoped>
@import '../../assets/style/layout/variables';

.h2Title {
  @include h2-title;
}

.fieldWrap {
  @include form-bx;

  .fieldBx {
    position: relative;
    width: 1600px;

    .searchBtn {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 1.7%;
    }

    .formList {
      display: flex;
      flex-direction: row;
      margin-bottom: 10px;

      dl {
        display: flex;
        align-items: center;
        flex-direction: row;
        margin-right: 20px;

        .formTit {
          @include form-font;
        }

        dd {
          display: flex;
          align-items: center;

          span {
            margin-left: 8px;
          }

          &:nth-child(2) {
            padding-left: 5px;
            padding-bottom: 3px;
          }

          .monthBx {
            display: flex;
            align-items: center;
            height: 35px;
            border-radius: 3px;
            border: 1px solid #1867c0;

            .month {
              &:first-child {
                padding-left: 10px;
              }

              height: 100%;
              padding: 0 8px;
              border: 0;
              background: #fff;
              font-size: 13px;
              font-weight: normal;
              color: #1867c0;

              &.active {
                background: #1867c0;
                color: #fff;
              }
            }
          }
        }
      }
    }
  }
}

.tableWrap {
  .tableBtnBx {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .searchAll {
      display: flex;
      align-items: center;
      margin-bottom: 0;
      /*font-size: 13px;*/
      .txtPoint {
        color: $point-color;
      }
    }
  }

  .tableBtn {
    ul {
      display: flex;
      flex-direction: row;
      align-items: center;

      .tableBtnList {
        margin-right: 15px;
      }
    }
  }
}
</style>